// Maps our i18n language codes to the codes the widget's `language_override` expects.
// Mirrors the date-fns locale mapping in src/lib/i18nDate.ts (ua -> uk, by -> be — those
// are the real ISO 639-1 codes; 'ua'/'by' are just our own i18n resource-file keys).
const LOCALES: Record<string, string> = { pl: 'pl', en: 'en', ua: 'uk', by: 'be' };

export function toSupportWidgetLocale(lang: string): string {
  return LOCALES[lang] ?? 'en';
}
